import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Step2Styles } from './Style'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { Words } from 'pages'
import { visibleTypes } from 'keys'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { IconButton } from '@mui/material'
import { Img } from 'styles/GlobalStyle'
import { Pause, PlayArrow } from '@mui/icons-material'
import { AnimatePresence } from 'framer-motion'
import { Go1Gif } from 'assets'
import { getWordDefsFetch } from 'store/middlewares/words.crud'
import { Record7 } from 'records'
import { AbilityContext } from 'components/Permissions/Can'
import { screen_2_letter_vowel_clusters_demo_female, screen_2_letter_vowel_clusters_demo_male, screen_2_letter_naming_demo_female, screen_2_letter_naming_demo_male, screen_2_letter_sounds_demo_female, screen_2_letter_sounds_demo_male, screen_2_word_list_demo_female, screen_2_word_list_demo_male, screen_2_vowel_sound_demo_male } from 'record1'
import * as motion from "motion/react-client"
import ReactPlayer from 'react-player'
import categories from 'keys/categories'

const Step2 = () => {
    const { assessmentDef, setCurrentStep, isMaleGender } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const queryClient = useQueryClient()
    const ability = useContext(AbilityContext)

    const visibleType = {
        [visibleTypes.PARAGRAPH]: {
            record: null,
            assessmentId: null
        }
    }

    const assessmentDefItem = {
        ["default"]: {
            assessmentId: null
        },
        [categories.LETTER_NAMING]: {
            record: isMaleGender ? screen_2_letter_naming_demo_male : screen_2_letter_naming_demo_female,
            assessmentId: 84,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 1000,
            boldWordAfterSeconds: isMaleGender ? 7500 : 7500
        },
        [categories.INFORMATIONAL_TEXT]: {
            record: isMaleGender ? screen_2_word_list_demo_male : screen_2_word_list_demo_female,
            assessmentId: 40,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 1000,
            boldWordAfterSeconds: isMaleGender ? 7000 : 6000
        },
        [categories.REAL_WORDS]: {
            record: isMaleGender ? screen_2_word_list_demo_male : screen_2_word_list_demo_female,
            assessmentId: 40,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 860,
            boldWordAfterSeconds: isMaleGender ? 7000 : 9400
        },
        [categories.LETTER_SOUNDS]: {
            record: isMaleGender ? screen_2_letter_sounds_demo_male : screen_2_letter_sounds_demo_female,
            assessmentId: 79,
            changeBoldWordAfterSeconds: isMaleGender ? 1000 : 900,
            boldWordAfterSeconds: isMaleGender ? 9500 : 8700
        },
        [categories.VOWEL_SOUND]: {
            record: isMaleGender ? screen_2_vowel_sound_demo_male : screen_2_vowel_sound_demo_male,
            assessmentId: 88,
            changeBoldWordAfterSeconds: isMaleGender ? 750 : 750,
            boldWordAfterSeconds: isMaleGender ? 7200 : 8200
        },
        [categories.LETTER_VOWEL_CLUSTERS]: {
            record: isMaleGender ? screen_2_letter_vowel_clusters_demo_male : screen_2_letter_vowel_clusters_demo_female,
            assessmentId: 67,
            changeBoldWordAfterSeconds: isMaleGender ? 880 : 880,
            boldWordAfterSeconds: isMaleGender ? 8800 : 9800
        }
    }
    const item = assessmentDefItem?.[assessmentDef?.category_name]

    const wordDefsData = useQuery({
        queryFn: [qc.exampleWordDefs],
        queryFn: async ({ signal }) => {
            if (item) {
                const { data } = await getWordDefsFetch({ signal, id: item.assessmentId })
                return data.word_defs
            }
        },
        refetchOnWindowFocus: false
    })

    const goNextStep = useCallback(() => {
        setCartoonSpeaking(false)
        queryClient.removeQueries([qc.exampleWordDefs])
        setCurrentStep(currentStep => currentStep + 1)
    }, [])

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    useEffect(() => {
        if (assessmentDef?.visible_type && !item?.assessmentId && assessmentDef.visible_type === visibleTypes.PARAGRAPH) {
            goNextStep()
        }
    }, [assessmentDef])

    return (
        <Step2Styles>
            <div className='wrap-content-with-cartoon'>
                <AnimatePresence>
                    <div className='wrap-cartoon-img'>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ y: 1, x: 1, opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.7 }}
                            className='cartoon-img'
                            key="cartoon-img"
                        >
                            <Img src={cartoonSpeaking ? Go1Gif : Go1Gif} />
                            <div className='play-pause-cartoon'>
                                <IconButton onClick={handleCartoonSpeaking}>
                                    {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                </IconButton>
                            </div>
                        </motion.div>
                    </div>
                </AnimatePresence>
                {wordDefsData?.data &&
                    <Words
                        cartoonSpeaking={cartoonSpeaking}
                        handleCartoonSpeaking={() => setCartoonSpeaking(!cartoonSpeaking)}
                        showCartoon={true}
                        print={true}
                        type={assessmentDef?.visible_type}
                        name={assessmentDef?.name}
                        words={wordDefsData?.data}
                        student={true}
                        handleNext={goNextStep}
                        boldWordAfterSeconds={item?.boldWordAfterSeconds}
                        changeBoldWordAfterSeconds={item?.changeBoldWordAfterSeconds}
                        hideNextButton={!ability.can("manage", "super-user")}
                    />}
            </div>
            {item?.record &&
                <ReactPlayer
                    playing={cartoonSpeaking}
                    url={item?.record}
                    controls={true}
                    width='0px' height='0px'
                    onEnded={() => {
                        // setTimeout(() => {
                        goNextStep()
                        // }, 2000)
                    }}
                />}
        </Step2Styles>
    )
}

export default Step2